<template>
  <div class="webview flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col xs="12">
          <div class="clearfix">
            <h1 class="web-hidden">1on1navi: Help</h1>
            <div role="tablist">
              <b-card
                v-for="(help, idx) in helps"
                v-bind:key="'help'+idx"
              no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn block href="#" v-b-toggle="'help' + idx" variant="info">{{ help.head }}</b-btn>
                </b-card-header>
                <b-collapse :id="'help' + idx" accordion="helpAccordion" role="tabpanel">
                  <b-card-body>
                    <p class="card-text" v-html="help.body"></p>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<style scoped>
.webview {
  overflow: auto;
}
h1 {
  text-align: center;
  font-size: 1.7rem;
}
h2 {
  font-size: 1.25rem;
}
h3 {
  font-size: 1.15rem;
}
h2 > span {
  margin-left: 1em;
  text-decoration: underline;
}
span.nth {
  margin-right: 0.5em;
}
ul.list-adjusted {
  padding-left: 1.5em;
}
.card-header .btn {
  white-space: normal;
  text-align: left;
}
</style>

<script>
export default {
  name: 'WebViewHelpsENRe',
  data () {
    return {
      'helps': [
        {
          head: 'Basic menu of 1on1navi',
          body: `The following icons located on the left side of the top screen.
          <ul class="list-adjusted">
          <li>・${this.$t('topTitle')}</li>
          <li>・${this.$t('oneOnTitleType')}</li>
          <li>・${this.$t('rtfbType')}</li>
          <li>・${this.$t('sidebar.people.title')}</li>
          <li>・Report</li>
          </ul>`
        },
        {
          head: 'Search for a user',
          body: `Click "${this.$t('searchUserStr')}" in "People" of the basic menu to display the search field and a list of recently checked users.<br><br>
                 Enter the username in the search field and the search results will be displayed. Information (profile, ${this.$t('topTitle')}, ${this.$t('oneOnTitleType')}, ${this.$t('rtfbType')}) will be displayed by clicking the corresponding username.`
        },
        {
          head: `Click ${this.$t('popTitleStr3Type')}`,
          body: `By creating a group, it becomes possible to set the publishing range of ${this.$t('topTitle')}, ${this.$t('oneOnTitleType')}, and ${this.$t('rtfbType')} to the users registered in the group, and to perform settings to receive notifications of group members collectively.<br>
          Click "${this.$t('groupRegTitle')}" in "People" of the basic menu to display a create screen.<br><br>
          After entering the group name, click the icon "+ ${this.$t('addMembersString')}" to search for users and select them when the user is displayed (checked). ※You can also select candidate group members already created from the group tab at once.<br>
          Click "${this.$t('saveStr')}" to create a group.<br>
          The created group can also be checked from the menu "${this.$t('groupListStr')}".`
        },
        {
          head: `Register ${this.$t('tutorial[1].head')}（Register ${this.$t('okrDetailType')} and ${this.$t('keyResultDetailType')}）`,
          body: `Click "${this.$t('okrRegisType')}" in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('okrDetailType')} registration screen.<br><br>
          From the ${this.$t('okrDetailType')} registration screen, enter and select the following items.
          <ul class="list-adjusted">
            <li>・${this.$t('okrDetailType')}：Register the contents of ${this.$t('okrDetailType')} by character input.</li>
            <li>・${this.$t('dueDateStr')}：It is possible to set from the "${this.$t('dueDateStr')}" by clicking. Unless otherwise specified, it will be the date you input.</li>
            <li>・${this.$t('progressRateLabelTitle')}：Progress rate can be set by dragging a circular gauge. You can also change it directly by entering the numbers in the circular gauge.</li>
            <li>・${this.$t('releaseLabelTitle')} : You can set by clicking "+" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.</li>
            <li>・${this.$t('relatedOkrType')}：You can click  "+${this.$t('addStr')}" on the right to search and select a user to display the user's ${this.$t('sidebar.okr.list')}, click ${this.$t('okrDetailType')} or ${this.$t('keyResultDetailType')}, and set it as ${this.$t('relatedOkrType')}.</li>
          </ul>
          Click "${this.$t('saveStr')}" or "${this.$t('popTitleStr2Type')}" to complete registration or draft saving.
          After registering ${this.$t('okrDetailType')}, you can continue to register ${this.$t('keyResultDetailType')}. ${this.$t('keyResultDetailType')} can be registered by clicking the "+ ${this.$t('addKeyResultStr')}" button at the bottom of ${this.$t('okrDetailType')} in the ${this.$t('sidebar.okr.list')}. The registered contents of ${this.$t('keyResultDetailType')} are the same as registered contents of ${this.$t('okrDetailType')}.`
        },
        {
          head: `Confirm ${this.$t('topTitle')}`,
          body: `Click "${this.$t('topTitle')}" list in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('sidebar.okr.list')}.<br><br>
          For ${this.$t('okrDetailType')}, progress rate, content, ${this.$t('dueDateStr')}, number of comments, number of ${this.$t('relatedOkrType')} are displayed, and information of ${this.$t('keyResultDetailType')} linked to ${this.$t('okrDetailType')} is displayed below.<br>
          ※If the number of comments and ${this.$t('relatedOkrType')} numbers is orange and bold, there are unread comments and ${this.$t('relatedOkrType')}.<br><br>
          You can confirm the details by selecting ${this.$t('okrDetailType')} or ${this.$t('keyResultDetailType')} you want to confirm the details from the ${this.$t('sidebar.okr.list')}. The following items are displayed.
          <ul class="list-adjusted">
            <li>・Start date </li>
            <li>・${this.$t('okrDetailType')} ※If there are a lot of characters, it will be highlighted, but you can check the contents by Clicking the "${this.$t('moreBtnTitle')} ".</li>
            <li>・${this.$t('dueDateStr')}</li>
            <li>・${this.$t('releaseLabelTitle')}</li>
            <li>・Progress rate</li>
            <li>・${this.$t('commentTabTitle')}</li>
            <li>・${this.$t('relatedOkrType')} ※${this.$t('relatedOkrType')} also display ${this.$t('topTitle')} associated with other users.</li>
          </ul>`
        },
        {
          head: `Associate ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) as ${this.$t('relatedOkrType')}.`,
          body: `Click "${this.$t('sidebar.okr.list')}" in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Click ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) to be related from the ${this.$t('sidebar.okr.list')}, and the details of ${this.$t('okrDetailType')} (/ ${this.$t('keyResultDetailType')}) will be displayed on the right side of the screen.<br>
          When you click the ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) you want to associate, the clicked ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) will be displayed on the right side of the screen.  If you click "${this.$t('relatedOkrType')}" (to the right of "${this.$t('commentTabTitle')}"), "+ Add ${this.$t('relatedOkrType')}" button will be displayed.<br><br>
          Click "+ Add ${this.$t('relatedOkrType')}", and search for the user who has set the ${this.$t('tutorial[1].head')} you want to associate in the "${this.$t('searchWithUserName')}" field.<br>
          In addition, if there is a user checked before, a list will be displayed.<br><br>
          The user who has set the ${this.$t('tutorial[1].head')} you want to associate is displayed, so click it to display the ${this.$t('sidebar.okr.list')} of that user.<br><br>
          When you click the ${this.$t('tutorial[1].head')} that you want to associate, "+ Add ${this.$t('relatedOkrType')}" window is displayed. When you click "${this.$t('modalOkStr')}", "${this.$t('compStorageStr')}" window is displayed and the association is made.<br><br>
          You can check the associated ${this.$t('tutorial[1].head')} in the "${this.$t('relatedOkrType')}" field on the right side of the screen.`
        },
        {
          head: `Change the progress rate of ${this.$t('tutorial[1].head')}`,
          body: `Click "${this.$t('sidebar.okr.list')}" in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Click ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) you want to change to display ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) on the right side of the screen.<br><br>
          There are two ways to change the progress rate:
          <ul class="list-adjusted">
            <li>・Click the numbers in the circular gauge and enter the progress rate</li>
            <li>・Click on the edge of the circular gauge to change the progress rate (slide can be fine-tuned) </li>
          </ul>
          "${this.$t('popTitleStrType')}: ${this.$t('confirmUpdateProgressStr')}? " window open, so click "${this.$t('modalOkStr')}” to change.`
        },
        {
          head: 'Complete OKR, Confirm Completed OKR',
          body: `Click "${this.$t('sidebar.okr.list')}" in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Click "..." (to the right of "Duedate") of ${this.$t('okrDetailType')} (/${this.$t('keyResultDetailType')}) you want to complete, and click "${this.$t('toComplete')}" from the displayed items.<br><br>
          "${this.$t('popTitleStrType')}: ${this.$t('popMessageStr16')} " window open. If you click "${this.$t('modalOkStr')}",<br>
          "${this.$t('popTitleStr8')}: ${this.$t('popMessageStr17')}" window will open. Click "${this.$t('modalOkStr')}", to be completed.<br><br>
          Click "${this.$t('sidebar.okr.complete')}" in ${this.$t('topTitle')} of the basic menu to display the ${this.$t('completeOkrType')}.`
        },
        {
          head: `Change the order of ${this.$t('okrDetailType')} displayed in the ${this.$t('sidebar.okr.list')}  `,
          body: `Click "${this.$t('sidebar.okr.list')}" in "${this.$t('topTitle')}" of the basic menu to display the ${this.$t('sidebar.okr.list')}.<br><br>
          Click "${this.$t('sortSettingString')}" button in the upper right of the "${this.$t('sidebar.okr.list')}" screen to display the list and rearrange Objectives.<br>
          Sorting can be done by clicking one of the following items.
          <ul class="list-adjusted">
            <li>・${this.$t('registerDescending')}</li>
            <li>・${this.$t('registerAscending')}</li>
            <li>・${this.$t('updateDescending')}</li>
            <li>・${this.$t('updateAscending')}</li>
          </ul>`
        },
        {
          head: 'Register the reflection of on 1on1',
          body: `Click "Create Review" in "${this.$t('oneOnTitleType')}" of the basic menu to create review.<br><br>
          "${this.$t('dateLabelTitle')}" can be set by selecting from the calendar. Unless otherwise specified, it will be the date you input.<br><br>
          "${this.$t('publicSettingLabelTitle')}" can also be set by clicking the icon "+${this.$t('addStr')}" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.<br><br>
          The contents of reflection are registered in each field of the following items by character input.
          <ul class="list-adjusted">
            <li>・${this.$t('firstContent1on1')}</li>
            <li>・${this.$t('secondContent1on1')}</li>
            <li>・${this.$t('thirdContent1on1')}</li>
            <li>・${this.$t('memoContent1on1')} ※It is private regardless of the above public settings.</li>
          </ul>
          Click "${this.$t('saveStr')}" or "${this.$t('popTitleStr2Type')}" to complete registration or draft saving.`
        },
        {
          head: 'Confirm 1on1’s reflection',
          body: `Click "Review list" in "${this.$t('oneOnTitleType')}" of the basic menu to display a list of implemented ${this.$t('tutorial[2].head')} in order from the latest.<br><br>
          From the ${this.$t('tutorial[2].head')} list, select ${this.$t('tutorial[2].head')} you want to check the details, and click the next item to check the details.
          <ul class="list-adjusted">
          <li>・${this.$t('firstContent1on1')}</li>
          <li>・${this.$t('secondContent1on1')}</li>
          <li>・${this.$t('thirdContent1on1')}</li>
          <li>・${this.$t('memoContent1on1')}</li>
          </ul>`
        },
        {
          head: `Send ${this.$t('oneOnOneRequest')}`,
          body: `Click "Send request" in "${this.$t('oneOnTitleType')}" of the basic menu to display "${this.$t('oneOnOneRequest')}".<br><br>
          Set "To" by clicking "+" on the right.<br><br>
          In the "Comment" field, register the contents of 1on1 request by character input.<br><br>
          If you click "${this.$t('senderTitle')}" below the comment field, 1on1 request will be sent to the destination.<br><br>
          Click "Request Sent History" in "${this.$t('oneOnTitleType')}" of the basic menu to display 1on1 Requests History.`
        },
        {
          head: `View ${this.$t('tutorial[3].head')}`,
          body: `Click "${this.$t('sidebar.rtfbs.list')}" in "${this.$t('tutorial[3].head')}" of the basic menu to display the list of ${this.$t('rtfbType')}.<br>
          If you select the content you want to see, you will advance to the corresponding page (${this.$t('rtfbDetailType')}).<br>
          You can see everything that the person wrote by clicking "…" on the right.`
        },
        {
          head: `Post ${this.$t('tutorial[3].head')}`,
          body: `Click "${this.$t('rtfbRegisType')}" in "${this.$t('tutorial[3].head')}" of the basic menu to register ${this.$t('tutorial[3].head')}.<br><br>
          "${this.$t('publicSettingLabelTitle')}" can also be set by clicking "+ ${this.$t('addStr')}" on the right. Unless otherwise specified, the disclosure range is ${this.$t('allPeopleStrType')}.<br><br>
          Register the content of F${this.$t('tutorial[3].head')} in the "${this.$t('contentsLabelTitle')}" field by character input.<br><br>
          Click "${this.$t('saveStr')}" or "${this.$t('popTitleStr2Type')}" to complete registration or draft saving.`
        },
        {
          head: 'Post comments',
          body: `In the details of ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')} and ${this.$t('tutorial[3].head')}, when you click the icon "balloon" at the lower left of the content you want to comment, a rectangular frame with "${this.$t('commentTabTitle')}" is displayed at the bottom of the screen. Enter a comment in the box and then click "${this.$t('senderTitle')}" button.`
        },
        {
          head: `Put on "${this.$t('likesCountStr')}"`,
          body: `If you want to "Like" ${this.$t('tutorial[3].head')}, tap the gray ☆ mark below the content of the ${this.$t('sidebar.rtfbs.list')}.<br>
          Alternatively, you can click the corresponding ${this.$t('tutorial[3].head')} to display the detail screen, and click the gray ☆ mark below the ${this.$t('tutorial[3].head')} contents to add a “Like". If ☆ becomes orange, it means "Like"<br><br>
          If you want to "Like" comments on ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')}, ${this.$t('tutorial[3].head')}, click the gray ☆ mark below the comment you want to "Like".  If ☆ becomes orange, it means "like"`
        },
        {
          head: 'View notification',
          body: `If there is a number next to “bell” icon in the upper right of the screen, you will see an unread notification.<br><br>
          To see the notification details, click "bell" icon and "${this.$t('indicateAllNotice')}". If you want to see detailed information such as ${this.$t('tutorial[1].head')}, ${this.$t('tutorial[2].head')}, ${this.$t('tutorial[3].head')}, etc. targeted for notification, select from the list and tap to go to the corresponding page.`
        },
        {
          head: 'Allow other users to receive notifications',
          body: `Click "${this.$t('sidebar.notice.list')}" in "${this.$t('sidebar.notice.title')}" of the basic menu to display "${this.$t('noticeSettingTitle')}".<br><br>
          Select "+ ${this.$t('addStr')}" button in the center of the screen and select the user you want to add. (Multiple choices are possible)<br>
          Since the user to be added is displayed in the center of the screen, if it is OK, you can receive notifications by selecting ${this.$t('saveStr')} button.<br>
          You can receive the following notifications for the configured user actions;
          <ul class="list-adjusted">
            <li>・Create / update / delete ${this.$t('tutorial[1].head')}</li>
            <li>・Create / update / delete ${this.$t('tutorial[2].head')}</li>
            <li>・Create / update / delete ${this.$t('tutorial[3].head')}</li>
          </ul>`
        },
        {
          head: 'Confirm receipt of 1on1 request',
          body: `Click "${this.$t('sidebar.one.reception')}" in "${this.$t('sidebar.notice.title')}" of the basic menu to display request reception history and select the message you want to see, and check the details (source and comments).`
        },
        {
          head: `${this.$t('profileEditTitleStr')}`,
          body: `Click the picture or name on the top left of the screen, or click "${this.$t('editStr')}" displayed at the center of the screen.<br>
          Select and enter the item you want to edit. (※ Email address is cannot be changed. )<br>
          When input is complete, select "${this.$t('saveStr')}" button to finish.`
        },
        {
          head: 'Change Conditions',
          body: `It can be changed by selecting from the list of conditions by directly clicking the weather mark displayed in the profile at the upper left of the screen.`
        },
        {
          head: 'Log out',
          body: `Click "${this.$t('logOutString')}" button in the upper right.`
        },
        {
          head: `Confirm the ${this.$t('OKRReportStr')}`,
          body: `Click "${this.$t('OKRReportStr')}" in "Report" of the basic menu to display the list of ${this.$t('OKRReportStr')}.<br>
          Search for and select the user for whom you want to check ${this.$t('tutorial[1].head')} or related OKR.<br>
          The user's ${this.$t('tutorial[1].head')} will be displayed, and the related OKR will also be displayed when clicked.<br>
          You can also specify the duedate.`
        },
        {
          head: `Confirm the ${this.$t('1on1ReportStr')}`,
          body: `Click "${this.$t('1on1ReportStr')}" in "Report" of the basic menu to display the list of ${this.$t('1on1ReportStr')}.<br>
          Search for and select the user for whom you want to check 1on1 reflections / OKR reflections<br>
          The user’s 1on1 reflections and the valid OKR on that date will be displayed when clicked.<br>
          You can also specify the duedate.`
        }
      ]
    }
  }
}
</script>
<style scoped>
  .web-hidden{
    display: none;
  }
  .p-1{
   padding: 0.5rem !important;
   transition: 0.2s all;
  }
  .card-header .btn{
    margin-top: 0;
  }
  .btn-info{
    background-color: #ffffff;
    border-color: #fcfcfc;
    padding: 0.8rem 1rem;
  }
  .btn-info:hover,.btn-info:focus, .btn-info.focus {
    color: #fff;
    background-color: #39b2d5;
    box-shadow: none;
  }
  .mb-1, .my-1{
    margin-bottom: 0.5rem !important;
  }
  .card-body, .card-block{
    padding: 1.5rem 1.8rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/_webview/WebViewHelpsENRe.vue